import { MultiOption } from 'editor/src/store/variants/types';

function isObjectMatchingDepOptions(object: { [key: string]: string }, option: MultiOption) {
  return option.dependedOptions.every((depOption) => object[depOption.key] === depOption.value);
}

export default isObjectMatchingDepOptions;
